// GoogleSheetAuthButton.jsx
import React from 'react';
import { GoogleOAuthProvider, GoogleLogin, CredentialResponse } from '@react-oauth/google';
import jwtDecode from 'jwt-decode';
import { appConfig } from '@common/config/app.config'; // Ensure this contains your client ID

type GoogleSheetAuthButtonProps = {
  onAuthSuccess: (auth: { credential: string | undefined; email: string }) => void;
};

const GoogleSheetAuthButton = ({ onAuthSuccess }: GoogleSheetAuthButtonProps) => {


  const handleSuccess = (credentialResponse: CredentialResponse) => {
    const credential = credentialResponse.credential;
    console.log('Credential Response:', credentialResponse);

    // Decode the JWT token
    const decoded = jwtDecode<{ email: string }>(credential ?? '');
    console.log('Decoded JWT: email present', !!decoded.email);

    // Extract the email from the decoded token
    const email = decoded.email;
    console.log('User Email:', email);

    onAuthSuccess({credential, email});
  };

  return (
    <GoogleOAuthProvider clientId={appConfig.google_client_id}>
      <GoogleLogin
        onSuccess={handleSuccess}
        onError={() => {
          console.error('Login Failed');
        }}
      />
    </GoogleOAuthProvider>
  );
};

export default GoogleSheetAuthButton;
